<template>
  <div>
    <a-table :columns="columns" :data-source="datalist" bordered :pagination="pagination" :scroll="{ x: 1200, y: 500 }"
      :loading="loading.table" size="small" key="tblMonitoring" :rowKey="(record, index) => { return index; }">
      <template slot="title">
        <div class="ant-card-head p-all">
          <div class="ant-card-head-wrapper">
            <div class="ant-card-head-title" style="padding:0px!important;">
              <div slot="title" class="d-flex flex-row justify-between nowrap">
                <span>
                  <a-icon type="pic-center" />
                  &nbsp;&nbsp;Daftar Prorasi & Penalti Karyawan
                </span>
                <div class="d-flex flex-row">
                  <div>
                    <span style="padding-right:5px">Generate Periode : </span>
                    <a-month-picker v-model="g_periode" :allowClear="true" :disabled-date="disabledperiodeDate"
                      placeholder="Pilih Periode" style="float:right;width:120px" />
                  </div>
                  <a-button type="primary" style="margin-left:16px" @click="handleGenerate" :loading="loading.generate"
                    :disabled="g_periode == null">Generate</a-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="act-grid" style="margin-top:12px">
          <a-row :gutter="{ xs: 0, lg: 8 }">
            <a-col :xs="24" :lg="16">
              <a-input-search v-model="qsearch" ref="search" @change="cari" placeholder="Pencarian ... " class="m-right"
                :loading="loading.search">
              </a-input-search>
            </a-col>
            <a-col :xs="24" :lg="4" class="d-flex flex-col">
              <a-month-picker v-model="f_periode" :allowClear="false" placeholder="Filter Periode" class="w-full" />
            </a-col>
            <a-col :xs="24" :lg="4" class="d-flex flex-row">
              <a-select v-model="f_tlc" show-search allow-clear placeholder="Filter TLC" :filterOption="optionFilter"
                class="w-full">
                <a-select-option v-for="item in getKaryawan" :key="item.tlc">{{
                  item.tlc + " - " + item.nama
                }}</a-select-option>
              </a-select>
            </a-col>
          </a-row>
        </div>
      </template>
      <template slot="no" slot-scope="item, data, index">
        {{ index + 1 + (pagination.page > 1 ? (pagination.page * pagination.pageSize) : 0) }}
      </template>
      <template slot="name" slot-scope="item">
        {{ item.tlc }} - {{ item.nama }}
      </template>
      <template slot="posisi" slot-scope="item">
        {{ item.posisi }}
      </template>
      <template slot="prorasi" slot-scope="item">
        {{ item.persentase_prorasi ? item.persentase_prorasi : 0 }}
      </template>
      <template slot="penalti" slot-scope="item">
        {{ item.penalty ? item.penalty : 0 }}
      </template>
      <template slot="keterangan" slot-scope="item">
        {{ item.keterangan }}
      </template>
      <template slot="aksi" slot-scope="item">
        <a-button icon="edit" @click="handleOpenModal(item)">Edit Prorasi</a-button>
      </template>
    </a-table>

    <a-modal v-if="modal.visible" v-model="modal.visible" centered :maskClosable="false" @cancel="handleCloseModal"
      @ok="handleOKModal" :confirmLoading="loading.modalok">
      <template slot="title">
        <h3>UPDATE PRORASI & PENALTI KARYAWAN</h3>
      </template>
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item label="TLC" prop="tlc">
          <a-input disabled v-model="form.tlc" />
        </a-form-model-item>
        <a-form-model-item label="Prorasi (%)" prop="prorasi">
          <a-input-number v-model="form.prorasi" :min="0" />
        </a-form-model-item>
        <a-form-model-item label="Penalti (%)" prop="penalti">
          <a-input-number v-model="form.penalti" :min="0" />
        </a-form-model-item>
        <a-form-model-item label="Keterangan" prop="keterangan">
          <a-textarea placeholder="Tulis keterangan disini ... " :rows="4" v-model="form.keterangan" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
//import Grid from "@/components/AbsensiGrid.vue";
import moment from "moment";
import _ from "lodash";

export default {
  name: "MonitoringAlokasiPekerjaan",
  props: ["spesialFor"],
  components: {
    //"H-AbsensiGrid": Grid,
  },
  data() {
    return {
      datalist: [],
      datalistOri: [],
      pagination: {
        page: 1,
        onChange: (page) => {
          this.pagination.page = page;
        },
        pageSize: 50,
        size: "default"
      },
      loading: {
        generate: false,
        table: false,
        search: false,
        modalok: false
      },
      modal: {
        visible: false
      },
      f_periode: null,
      f_tlc: null,
      g_periode: null,
      qsearch: null,
      form: {
        id_prorasi_dtl: null,
        tlc: null,
        prorasi: null,
        penalti: null,
        keterangan: null
      },
      rules: {
        prorasi: [
          {
            required: true,
            message: "Please input Prorasi!",
            trigger: "change",
          },
        ],
        penalti: [
          {
            required: true,
            message: "Please input Penalti!",
            trigger: "change",
          },
        ],
        keterangan: [
          {
            required: true,
            message: "Please input Keterangan!",
            trigger: "change",
          },
        ],
      },
      enabledPeriodList: []
    }
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate", "getKaryawan"]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const columns = [
        {
          title: 'No',
          scopedSlots: { customRender: "no" },
          width: 45,
          key: 'no',
          align: "right",
          fixed: this.isMobile ? false : "left",
        },
        {
          key: 'name',
          title: "Nama Karyawan",
          scopedSlots: { customRender: "name" },
          sorter: (a, b) => b.tlc.localeCompare(a.tlc),
        },
        {
          key: 'name',
          title: "Posisi",
          scopedSlots: { customRender: "posisi" },
          sorter: (a, b) => b.posisi.localeCompare(a.posisi),
        },
        {
          title: 'Prorasi (%)',
          key: 'prorasi',
          align: "center",
          width: "120px",
          scopedSlots: { customRender: "prorasi" },
          sorter: (a, b) => a.prorasi - b.prorasi,
        },
        {
          title: 'Penalti (%)',
          key: 'penalti',
          align: "center",
          width: "120px",
          scopedSlots: { customRender: "penalti" },
          sorter: (a, b) => a.penalti - b.penalti,
        },
        {
          title: 'Keterangan',
          align: "left",
          scopedSlots: { customRender: "keterangan" },
          sorter: (a, b) => b.keterangan.localeCompare(a.keterangan),
        },
        {
          title: 'aksi',
          key: 'aksi',
          width: "150px",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: 'aksi' },
        },
      ];
      return columns;
    },
  },
  methods: {
    moment,
    cari(val) {
      if (val && val.target.value) {
        this.datalist = this.datalistOri.filter(item =>
          item.tlc.toLowerCase().indexOf(val.target.value.toLowerCase()) >= 0 ||
          (item.keterangan && item.keterangan.toLowerCase().indexOf(val.target.value.toLowerCase()) >= 0))
      } else {
        this.datalist = this.datalistOri
      }

      if (this.f_tlc) {
        this.datalist = this.datalist.filter(item => item.tlc.toLowerCase() == this.f_tlc.toLowerCase())
      }
    },
    optionFilter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    kategoriChange() {

    },
    handleGenerate() {
      if (!this.g_periode) {
        this.displayMessageValue("error-basic", 'Pilih periode terlebih dahulu!');
        return;
      }

      let data = new FormData();
      data.append("periode", moment(this.g_periode).format('YYYY-MM'));

      this.loading.generate = true
      this.asyncAxiosPost(
        "prorasi",
        "formdata",
        this.getAuth,
        data
      )
        .then((response) => {
          this.datalist = response.dtl
          this.datalistOri = this.datalist

          this.f_periode = this.g_periode
          this.g_periode = null
          this.loading.generate = false
        })
        .catch(() => {
          this.loading.generate = false
        });
    },
    handleOpenModal(item) {
      this.form.id_prorasi_dtl = item.id_rekap_dtl
      this.form.tlc = item.tlc
      this.form.prorasi = item.persentase_prorasi
      this.form.penalti = item.penalty
      this.form.keterangan = item.keterangan
      this.modal.visible = true
    },
    handleCloseModal() {
      this.modal.visible = false
    },
    async handleOKModal() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        const payload = {
          id_prorasi_dtl: this.form.id_prorasi_dtl,
          tlc_prorasi: this.form.tlc,
          persentase_prorasi: this.form.prorasi,
          persentase_penalty: this.form.penalti,
          keterangan: this.form.keterangan
        }

        this.loading.modalok = true
        await this.asyncAxiosPut("prorasi", "json", this.getAuth, payload)
          .then((response) => {
            this.datalist = response.dtl
            this.datalistOri = this.datalist

            if (this.qsearch)
              this.cari({ target: { value: this.qsearch } })

            this.loading.modalok = false
            this.modal.visible = false
          })
          .catch(() => {
            this.loading.modalok = false
          });
      })
    },
    async getlist() {
      this.loading.table = true
      await this.asyncAxiosGet("prorasi", this.getAuth, { periode: moment(this.f_periode).format('YYYY-MM') })
        .then((response) => {
          this.datalist = response.dtl
          this.datalistOri = this.datalist

          if (this.qsearch)
            this.cari({ target: { value: this.qsearch } })

          this.loading.table = false
          this.modal.visible = false
        })
        .catch(() => {
          this.loading.table = false
        });
    },
    async getEnablePeriod() {
      this.loading.table = true
      await this.asyncAxiosGet("prorasi/periode", this.getAuth, {})
        .then((response) => {
          this.enabledPeriodList = response.periode
          this.loading.table = false
        })
        .catch(() => {
          this.loading.table = false
        });
    },
    disabledperiodeDate(val) {
      return this.enabledPeriodList.filter(item => item == moment(val).format('YYYY-MM')).length > 0 ||
        moment(val).format('YYYY-MM') == moment().format('YYYY-MM') ? false : true
    }
  },
  created() {
    this.$store.dispatch("FETCH_KARYAWAN");
  },
  mounted() {
    this.getEnablePeriod()
  },
  watch: {
    f_periode() {
      this.getlist().then(() => {
        this.cari({ target: { value: this.qsearch } })
      })
    },
    f_tlc() {
      this.cari({ target: { value: this.qsearch } })
    }
  }
}
</script>